import React from 'react';
import { Link } from 'react-router-dom';
import SharedConstants from 'common/constants/SharedConstants';

/**
 *  Nav Item Component
 * @param {*} props - Object
 */

const NavItemComp = props => {
  const { ariaLable, className = '', onClickHandler, name, ...rest } = props;
  /**
   * On Key Press Handler
   * @param {*} evt - Event Object
   */
  const onKeyPressHandler = evt => {
    // Char Code - Space and Enter
    const { SPACE, ENTER } = SharedConstants.KEY_CHAR_CODE;
    if (evt.charCode === SPACE || evt.charCode === ENTER) {
      // if onClickHandler is a method
      onClickHandler(name);
    }
  };

  return (
    <Link
      to={{}}
      data-testid='navItems'
      className={`navigation-link ${className} nav-item`}
      onClick={() => {
        onClickHandler(name);
      }}
      onKeyPress={onKeyPressHandler}
      {...rest}
    >
      <button className='header-item-buttons d-flex' tabIndex='-1'>
        {props.children}
      </button>
    </Link>
  );
};

export { NavItemComp };
